

export const TOGGLE_FILTER_LOADING = 'TOGGLE_FILTER_LOADING';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';

//sections
export const SECTION_BUSINESS_INFO = 'BUSINESS_INFO';
export const SECTION_EQUIPMENTS = 'EQUIPMENTS';
export const SECTION_PRICING = 'PRICING';
export const SECTION_BUSINESS_OUTLET_BANK = 'BUSINESS_OUTLET_BANK';
export const SECTION_PRINCIPAL = 'PRINCIPAL';
export const SECTION_OUTLET_INFORMATION = 'OUTLET_INFORMATION';


//modules
export const SET_APPLICATION_MODULE = 'application/';

//MUTATIONS
export const SET_APPLICATION_PAGE_TITLE = 'SET_APPLICATION_PAGE_TITLE';

export const SET_NAVIGATION = 'SET_NAVIGATION';
export const SET_APPLICATION_PARAMETERS = 'SET_APPLICATION_PARAMETERS';
export const SET_PARAMETERS = 'SET_PARAMETERS';
export const SET_PAGE_CONFIG = "SET_PAGE_CONFIG";
export const SET_BRANDING = "SET_BRANDING";
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";
export const SET_WORKFLOW_PERMISSIONS = "SET_WORKFLOW_PERMISSIONS";
export const SET_MERCHANT_USER_ACCESS = "SET_MERCHANT_USER_ACCESS";
export const SET_QUOTE_LOCK = "SET_QUOTE_LOCK";
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
export const SET_QUOTE_ROOT_PATH = 'SET_QUOTE_ROOT_PATH';
export const SET_APPLICATION_ROOT_PATH = 'SET_APPLICATION_ROOT_PATH';
export const SET_EQUIPMENT_OFFER = 'SET_EQUIPMENT_OFFER';
export const SET_ACQUIRING_OFFER = 'SET_ACQUIRING_OFFER';
export const SET_ONLINE_OFFER = 'SET_ONLINE_OFFER';
export const SET_GLOBAL_ERRORS = 'SET_GLOBAL_ERRORS';
export const SET_CAN_EDIT = 'SET_CAN_EDIT';
export const SET_CAN_VIEW = 'SET_CAN_VIEW';
export const COMMIT_QUOTE = 'COMMIT_QUOTE';
export const COMMIT_APPLICATION_TABS = 'COMMIT_APPLICATION_TABS';
export const SET_GO_BACK_WARNING_MODAL = 'SET_GO_BACK_WARNING_MODAL';
export const SET_LOADING_DOCUMENT_UPLOAD = 'SET_LOADING_DOCUMENT_UPLOAD';

//actions
export const FETCH_APPLICATION_PARAMETERS = 'FETCH_APPLICATION_PARAMETERS';
export const FETCH_APPLICATION_DATA = 'FETCH_APPLICATION_DATA';
export const FETCH_QUOTE_DATA = 'FETCH_QUOTE_DATA';
export const COMMIT_APPLICATION = 'COMMIT_APPLICATION';
export const COMMIT_OUTLETS = 'COMMIT_OUTLETS';
export const SELECT_PAGE_CONFIG = 'SELECT_PAGE_CONFIG';
export const EQUIPMENT_OFFERING = 'EQUIPMENT_OFFERING';
export const ACQUIRING_OFFERING = 'ACQUIRING_OFFERING';
export const ONLINE_OFFERING = 'ONLINE_OFFERING';
export const SET_MATCHED_PACKAGES = 'SET_MATCHED_PACKAGES';
export const INITIATE_QUOTE = 'INITIATE_QUOTE';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const CONVERT_QUOTE = 'CONVERT_QUOTE';
export const CONVERT_PUBLIC_QUOTE = 'CONVERT_PUBLIC_QUOTE';
export const CREATE_QUOTE_MERCHANT_USER = 'CREATE_QUOTE_MERCHANT_USER';


//getters
export const QUOTE_IN_VIEW_MODE = 'QUOTE_IN_VIEW_MODE';


export const UPDATE_OUTLETS = 'UPDATE_OUTLETS';
export const REMOVE_OUTLET = 'REMOVE_OUTLET';
export const ADD_OUTLET = 'ADD_OUTLET';
export const EDIT_OUTLET = 'EDIT_OUTLET';
export const EDIT_SUBGROUP = 'EDIT_SUBGROUP';
export const DELETE_SUBGROUP = 'DELETE_SUBGROUP';
export const DELETE_OUTLET = 'DELETE_OUTLET';
export const RELEASE_RESERVE = 'RELEASE_RESERVE';
export const SET_OUTLET_IN_FOCUS = 'SET_OUTLET_IN_FOCUS';
export const SET_GROUP_IN_FOCUS = 'SET_GROUP_IN_FOCUS';
export const GET_OUTLET_SUMMARY = 'GET_OUTLET_SUMMARY';
export const GET_MERCHANT_VALIDATION_ERRORS = 'GET_MERCHANT_VALIDATION_ERRORS';
export const GET_HIERARCHY_DAILY_INFO = 'GET_HIERARCHY_DAILY_INFO';
export const SET_ALLIANCE_DATA = "SET_ALLIANCE_DATA";
export const SET_SUPPORT_PHONE = "SET_SUPPORT_PHONE";
export const SET_MERCHANT_DATA = "SET_MERCHANT_DATA";
export const SET_DOCUMENTS_INSTANCE = "SET_DOCUMENTS_INSTANCE";
export const SET_APPLICATION_STATUS = "SET_APPLICATION_STATUS";
export const SET_QUOTE_STATUS = "SET_QUOTE_STATUS";
export const GET_REPORT = "GET_REPORT";
export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const SET_MY_LANGUAGE = "SET_MY_LANGUAGE";
export const SET_IS_PROVIDER = "SET_IS_PROVIDER";
export const SET_MERCHANT_HIERARCHY_DATA = "SET_MERCHANT_HIERARCHY_DATA";
export const SET_MERCHANT_RELATION_DATA = "SET_MERCHANT_RELATION_DATA";
export const SET_APPLICATION_RELATION_DATA = "SET_APPLICATION_RELATION_DATA";
export const SET_APPLICATION_SUBSTATUSES = "SET_APPLICATION_SUBSTATUSES";
export const SET_APPLICATION_STATUSES = "SET_APPLICATION_STATUSES";
export const SET_MERCHANT_SUB_GROUP_DATA = "SET_MERCHANT_SUB_GROUP_DATA";
export const SET_MERCHANT_TREE_DATA = "SET_MERCHANT_TREE_DATA";
export const SET_TREE_DESCENDANTS_DATA = "SET_TREE_DESCENDANTS_DATA";
export const SET_MERCHANT_USER_DATA = "SET_MERCHANT_USER_DATA";
export const SET_MAINTENANCE_DATA = "SET_MAINTENANCE_DATA";
export const SET_MERCHANT_HIERARCHY_CONFIGURATION_TEMPLATES = "SET_MERCHANT_HIERARCHY_CONFIGURATION_TEMPLATES";
export const SET_CHAIN_DATA = "SET_CHAIN_DATA";
export const SET_BILLING_DATA = "SET_BILLING_DATA";
export const SET_OUTLET_RELATION_DATA = "SET_OUTLET_RELATION_DATA";
export const SET_CURRENT_ACCOUNT_TYPE = "SET_CURRENT_ACCOUNT_TYPE";
export const SET_CURRENT_ACCOUNT_LIST = "SET_CURRENT_ACCOUNT_LIST";
export const SET_CURRENT_ACCOUNT_SUMMARY = "SET_CURRENT_ACCOUNT_SUMMARY";
export const SET_CURRENT_ACCOUNT_PARENT = "SET_CURRENT_ACCOUNT_PARENT";
export const SET_CURRENT_ACCOUNT_DETAILS = "SET_CURRENT_ACCOUNT_DETAILS";
export const QUALITY_CHECK = "QUALITY_CHECK";
export const SAVE_MERCHANT = "SAVE_MERCHANT";
export const SAVE_OUTLET = "SAVE_OUTLET";
export const SAVE_BANK_ID_PRINCIPAL_DATA = "SAVE_BANK_ID_PRINCIPAL_DATA";
export const UPDATE_SUB_GROUP = "UPDATE_SUB_GROUP";
export const ADD_SUB_GROUP = "ADD_SUB_GROUP";
export const SAVE_AML_EDIT = "SAVE_AML_EDIT";
export const GET_ACCOUNT_SUMMARY = "GET_ACCOUNT_SUMMARY";
export const SAVE_ACCOUNTS_SETTINGS = "SAVE_ACCOUNTS_SETTINGS";
export const DO_MANAGE_ACCOUNTS = "DO_MANAGE_ACCOUNTS";
export const VALIDATE_ACCOUNTS = "VALIDATE_ACCOUNTS";
export const SUBMIT_MERCHANTS = "SUBMIT_MERCHANTS";
export const UNLOCK_APPLICATION = "UNLOCK_APPLICATION";
export const SET_ACCOUNT_SUMMARY_ON_ACCOUNT_PARENT = "SET_ACCOUNT_SUMMARY_ON_ACCOUNT_PARENT";
export const SET_DYNAMIC_ACCOUNT_SUMMARY_ON_ACCOUNT_PARENT = "SET_DYNAMIC_ACCOUNT_SUMMARY_ON_ACCOUNT_PARENT";
export const SET_ACCOUNTS_SETTINGS = "SET_ACCOUNTS_SETTINGS";
export const SET_ACCOUNT_TYPES_ON_ACCOUNT_PARENT = "SET_ACCOUNT_TYPES_ON_ACCOUNT_PARENT";
export const SET_TRADE_OUTLET_ON_ACCOUNT_PARENT = "SET_TRADE_OUTLET_ON_ACCOUNT_PARENT";
export const SET_DYNAMIC_TRADE_OUTLET_ON_ACCOUNT_PARENT = "SET_DYNAMIC_TRADE_OUTLET_ON_ACCOUNT_PARENT";
export const SET_SETTLEMENT_VALUES_ON_ACCOUNT_PARENT = "SET_SETTLEMENT_VALUES_ON_ACCOUNT_PARENT";
export const GET_DAILY_INFO = "GET_DAILY_INFO";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const SET_OUTLETS = "SET_OUTLETS";
export const SHOW_ERROR_ALERT = "SHOW_ERROR_ALERT";
export const SET_LAST_CHAIN_PATH = "SET_LAST_CHAIN_PATH";
export const SET_LAST_TRANSACTION_PATH = "SET_LAST_TRANSACTION_PATH";
export const BANK = "BANK";
export const SET_LAST_OUTLET_TRANSACTION_PATH = "SET_LAST_OUTLET_TRANSACTION_PATH";
export const SET_OUTLET_FORM_DATA = "SET_OUTLET_FORM_DATA";
export const INIT_OUTLET_FORM_DATA = "INIT_OUTLET_FORM_DATA";
export const SET_QUOTE_DATA = "SET_QUOTE_DATA";
export const SET_LAST_OUTLET_PATH = "SET_LAST_OUTLET_PATH";
export const GET_HOLD_SUSPEND_FLAG = "GET_HOLD_SUSPEND_FLAG";
export const SET_OUTLET_TAB = "SET_OUTLET_TAB";
export const SET_CURRENT_NODE_TYPE = "SET_CURRENT_NODE_TYPE";
export const SET_CURRENT_NODE_DETAIL = "SET_CURRENT_NODE_DETAIL";
export const SET_DEFAULT_OUTLET_TAB_CONFIG = "SET_DEFAULT_OUTLET_TAB_CONFIG";
export const SET_DEFAULT_SUBGROUP_TAB_CONFIG = "SET_DEFAULT_SUBGROUP_TAB_CONFIG";
export const SET_SUBGROUP_TAB = "SET_SUBGROUP_TAB";
export const SET_MERCHANT_VALIDATION_ERRORS ='SET_MERCHANT_VALIDATION_ERRORS';
export const SET_PAYPAL_BOARDING = 'SET_PAYPAL_BOARDING';

// export const SECTION_GROUP_INFORMATION = 'GROUP_INFORMATION';
// export const SECTION_OUTLET_TRADING = 'OUTLET_TRADING';
// export const SECTION_OUTLET_EQUIPMENT_SERVICES = 'OUTLET_EQUIPMENT_SERVICES';
// export const SECTION_OUTLET_EQUIPMENT_SERVICES_AND_CHARGES = 'OUTLET_EQUIPMENT_SERVICES_AND_CHARGES';
export const SECTION_BANKS = "BANKS";


// MERCHANT STATUSES
export const MERCHANT_STATUS_OPEN = 1;
export const MERCHANT_STATUS_BOARDING_IN_PROGRESS = 2;
export const MERCHANT_STATUS_READY_FOR_VALIDATION = 3;
export const MERCHANT_STATUS_READY_FOR_ACCOUNT_CREATION = 4;
export const MERCHANT_STATUS_BOARDING_COMPLETE = 5;

//REPORT TYPES
export const REPORT_TYPE_AML = 'AML';
export const REPORT_TYPE_RISK = 'RISK';

//REASSIGN TYPES
export const REASSIGN_TYPE_QUALITY_REVIEWER = 'QUALITY_REVIEWER';
export const REASSIGN_TYPE_CREATOR = 'CREATOR';
export const REASSIGN_TYPE_OWNER = 'SALES_OWNER';
export const REASSIGN_TYPE_AML = 'AML';
export const REASSIGN = 'REASSIGN';

//OPERATIONS
export const AML_OPERATIONS = "AML_OPERATIONS";
export const AML_DECLINED = 'AML_DECLINED';
export const AML_DECLINE = 'AML_DECLINE';
export const AML_MORE_INFO_REQUIRED = 'AML_MORE_INFO_REQUIRED';
export const AML_APPROVE = 'AML_APPROVE';

//OPERATIONS
export const RISK_OPERATIONS = "RISK_OPERATIONS";
export const RISK_DECLINED = 'RISK_DECLINED';
export const RISK_MORE_INFO_REQUIRED = 'RISK_MORE_INFO_REQUIRED';
export const RISK_APPROVE = 'AML_APPROVE';

//QUOTE_STATUSES
export const QUOTE_STATUS_INITIATED = 'QUOTE_INITIATED';
export const QUOTE_STATUS_GENERATED = 'QUOTE_GENERATED';
export const QUOTE_STATUS_ACCEPTED = 'QUOTE_ACCEPTED';
export const QUOTE_STATUS_CONVERTED = 'QUOTE_CONVERTED';

// APPLICATION_STATUSES
export const APP_STATUS_OPEN = 'OPEN';
export const APP_STATUS_AWAITING_SIGNATURE = 'AWAITING_SIGNATURE';
export const APP_STATUS_AWAITING_REMOTE_SIGNATURE = 'AWAITING_REMOTE_SIGNATURE';
export const APP_STATUS_AWAITING_PAPER_SIGNATURE = 'AWAITING_PAPER_SIGNATURE';
export const APP_STATUS_AWAITING_ON_SCREEN_SIGNATURE = 'AWAITING_ON_SCREEN_SIGNATURE';
export const APP_STATUS_SIGNED = 'SIGNED';
export const APP_STATUS_READY_AML_REVIEW = 'READY_AML_REVIEW';
export const APP_STATUS_AML_REFERRED = 'AML_REFERRED';
export const APP_STATUS_AML_ERROR = 'AML_ERROR';
export const APP_STATUS_CREDIT_RISK_PRE_APPROVED = 'CREDIT_RISK_PRE_APPROVED';
export const APP_STATUS_CREDIT_RISK_REFERRED = 'CREDIT_RISK_REFERRED';
export const APP_STATUS_CREDIT_RISK_ERROR = 'CREDIT_RISK_ERROR'
export const APP_STATUS_AML_UNDER_REVIEW = 'AML_UNDER_REVIEW';
export const APP_STATUS_AML_MORE_INFO_REQUIRED = 'AML_MORE_INFO_REQUIRED';
export const APP_STATUS_UNDERWRITING_RETURN_TO_SALES = 'UNDERWRITING_RETURN_TO_SALES';
export const APP_STATUS_AML_APPROVE = 'AML_APPROVE';
export const APP_STATUS_AWATING_UNDERWRITING = 'AWATING_UNDERWRITING';
export const APP_STATUS_CREDIT_RISK_MORE_INFO_REQUIRED = 'CREDIT_RISK_MORE_INFO_REQUIRED';
export const APP_STATUS_UNDERWRITING_APPROVED = 'UNDERWRITING_APPROVED';
export const APP_STATUS_BOARDING_COMPLETE = 'BOARDING_COMPLETE';
export const APP_STATUS_CANCELLED = 'CANCELLED';
export const APP_STATUS_AML_DECLINED = 'AML_DECLINED';
export const APP_STATUS_UNDERWRITING_DECLINED = 'UNDERWRITING_DECLINED';
export const APP_STATUS_TNAP_AWAITING = 'TNAP_AWAITING';
export const APP_STATUS_READY_FOR_QUALITY_CHECK = 'READY_FOR_QUALITY_CHECK';
export const APP_STATUS_QUALITY_CHECK_IN_PROGRESS = 'QUALITY_CHECK_IN_PROGRESS';
export const APP_STATUS_QUALITY_CHECK_APPROVED = 'QUALITY_CHECK_APPROVED';
export const APP_STATUS_QUALITY_CHECK_MORE_INFO_REQUIRED = 'QUALITY_CHECK_MORE_INFO_REQUIRED';
export const APP_STATUS_QUALITY_CHECK_MORE_DOCUMENT_REQUIRED = 'QUALITY_CHECK_MORE_DOCUMENT_REQUIRED';

export const APP_STATUS_ARCHIVING_IN_PROGRESS = 'ARCHIVING_IN_PROGRESS';
export const APP_STATUS_ARCHIVING_SUCCESS = 'ARCHIVING_SUCCESS';
export const APP_STATUS_ARCHIVING_FAILED = 'ARCHIVING_FAILED';
export const APP_STATUS_DATA_COLLECTION_COMPLETE = 'DATA_COLLECTION_COMPLETE';
export const APP_STATUS_READY_FOR_BOARDING = 'READY_FOR_BOARDING';
export const APP_STATUS_AWAITING_BOARDING_COMPLETE = 'AWAITING_BOARDING_COMPLETE';
export const APP_STATUS_READY_FOR_MANUAL_BOARDING = 'READY_FOR_MANUAL_BOARDING';
export const APP_STATUS_SUBMISSION_IN_PROGRESS = 'SUBMISSION_IN_PROGRESS';
export const APP_STATUS_SUBMISSION_FAILED = 'SUBMISSION_FAILED';
export const APP_STATUS_DIGITAL_DATAPULL_FAILED = 'DIGITAL_DATAPULL_FAILED';
export const APP_STATUS_DIGITAL_SIGNATURE_FAILED = 'DIGITAL_SIGNATURE_FAILED';
export const APP_STATUS_DOCUMENT_PACKET_GENERATION_FAILED = 'DOCUMENT_PACKET_GENERATION_FAILED';
export const APP_STATUS_DOCUMENT_PACKET_GENERATION_IN_PROGRESS = 'DOCUMENT_PACKET_GENERATION_IN_PROGRESS';
export const APP_STATUS_BOARDING_IN_PROGRESS = 'BOARDING_IN_PROGRESS';

export const MFA_METHOD_PING = '1';
export const MFA_METHOD_EMAIL = '2';
export const MFA_METHOD_EMAIL_PING = '3';
export const MFA_METHOD_PING_PREFERRED = '3';

export const UNMASK_PII_DATA = 'UNMASK_PII_DATA';

//END POINTS
export const URL_BUSINESS_DETAILS = 'business_details';
export const URL_BUSINESS_INFO = 'business';
export const URL_SUBMISSION_REVIEW = 'review';

//Banks Excluded from Faster Payments
export const FASTER_PAYMENT_EXCLUDED_BANKS = ['SANTANDER UK PLC'];

//Nordic Bank ID - https://docs.criipto.com/how-to/acr-values
export const BANK_ID_ACR_VALUES_PARAM = {
    'urn:grn:authn:no:bankid': 'bank_id_mobile_or_web_user_choice',
    'urn:grn:authn:no:vipps': 'bank_id_login_with_vipps_app',
    'urn:grn:authn:se:bankid:same-device': 'bank_id_same_device',
    'urn:grn:authn:se:bankid:another-device': 'bank_id_another_device_aka_mobile',
    'urn:grn:authn:se:bankid:another-device:qr': 'bank_id_qr_code',
    'urn:grn:authn:dk:nemid:poces': 'bank_id_personal_with_code_card',
    'urn:grn:authn:dk:nemid:moces': 'bank_id_employee_with_code_card',
    'urn:grn:authn:dk:nemid:moces:codefile': 'bank_id_employee_with_code_file',
    'urn:grn:authn:dk:mitid:low': 'bank_id_level_low',
    'urn:grn:authn:dk:mitid:substantial': 'bank_id_level_substantial',
    'urn:grn:authn:fi:bank-id': 'bank_id_bank_id',
    'urn:grn:authn:fi:mobile-id': 'bank_id_mobile_certificate_mobiilivarmenne',
    'urn:grn:authn:fi:all': 'bank_id_any_of_the_two',
    'urn:grn:authn:itsme:basic': 'bank_id_basic',
    'urn:grn:authn:itsme:advanced': 'bank_id_advanced',
    'urn:grn:authn:be:eid:verified': 'bank_id_verified_e_id',
    'urn:grn:authn:de:sofort': 'bank_id_sofort_with_schufa_check',
}

export const DOCUMENT_REVIEW_STATUS_NOT_REVIEWED = '1';
export const DOCUMENT_REVIEW_STATUS_APPROVED = '2';
export const DOCUMENT_REVIEW_STATUS_CANCELLED = '3';
